export const LAST_7_DAYS_ID = "last-7-days";
export const LAST_15_DAYS_ID = "last_15-days";
export const LAST_30_DAYS_ID = "last-30-days";
export const CUSTOM_DAYS_ID = "custom_days";

export const LAST_7_DAYS: string = "Last 7 Days";
export const LAST_15_DAYS: string = "Last 15 Days";
export const LAST_30_DAYS: string = "Last 30 Days";
export const CUSTOM_DAYS: string = "Custom";
export const DATETIME_FORMAT: string = "yyyy-MM-ddTHH:mm:ss";
export const DATE_FORMAT: string = "dd/MM/yyyy";
export const TIME_FORMAT: string = "HH:mm";
export const IGNORE_DATETIME: string = "0001-01-01T00:00:00";

export const HOME_ADDRESS: string = "Home";
export const INSPECTION_PLACE_ADDRESS: string = "Inspection Place";
